import { Form, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { PendingIncomeRow } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import PendingIncomeTableBody from './PendingIncomeTableBody';

interface PendingIncomeTableProps {
    rows: PendingIncomeRow[];
    canAct: boolean;
    selected: number[];
    allSelected: boolean;
    saving: boolean;
    onToggle: (operationId: number) => void;
    onToggleAll: () => void;
    onAcceptAll: (operationId: number) => void;
    onAcceptPartial: (row: PendingIncomeRow) => void;
}

const PendingIncomeTable = ({
    rows,
    canAct,
    selected,
    allSelected,
    saving,
    onToggle,
    onToggleAll,
    onAcceptAll,
    onAcceptPartial,
}: PendingIncomeTableProps) => {
    const { t } = useTranslation(['Warehouses']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur show={saving} />
            <div className="crm-table-wrap">
                <Table className="PendingIncomeTable table-hover">
                    <thead>
                        <tr className="bg-light">
                            {canAct ? (
                                <td className="head-check">
                                    <Form.Check
                                        type="checkbox"
                                        checked={allSelected}
                                        disabled={saving}
                                        onChange={onToggleAll}
                                        aria-label={t('pendingIncome.acceptChecked')}
                                    />
                                </td>
                            ) : null}
                            <td className="head-username">{t('pendingIncome.fromUser')}</td>
                            <td className="head-warehouse">{t('pendingIncome.fromWarehouse')}</td>
                            <td className="head-name">{t('pendingIncome.product')}</td>
                            <td className="head-count">{t('pendingIncome.count')}</td>
                            {canAct ? <td className="head-accept">{t('pendingIncome.acceptColumn')}</td> : null}
                        </tr>
                    </thead>
                    <PendingIncomeTableBody
                        rows={rows}
                        canAct={canAct}
                        selected={selected}
                        saving={saving}
                        onToggle={onToggle}
                        onAcceptAll={onAcceptAll}
                        onAcceptPartial={onAcceptPartial}
                    />
                </Table>
            </div>
        </div>
    );
};

export default PendingIncomeTable;
